var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid mb-4 gs-header-filters" },
    [
      _c(
        "b-button",
        {
          staticClass: "header-filter-btns",
          class: _vm.isActive("all") ? "active" : "",
          attrs: { variant: "theme" },
          on: {
            click: function($event) {
              return _vm.activateTab("all")
            }
          }
        },
        [
          _vm._v("\n      All\n      "),
          _c("i", {
            staticClass: "fas text-primary fa-layer-group fa-fw float-right"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "ml-2 header-filter-btns",
          class: _vm.isActive("departments") ? "active" : "",
          attrs: { variant: "theme" },
          on: {
            click: function($event) {
              return _vm.activateTab("departments")
            }
          }
        },
        [
          _vm._v("\n      Departments\n      "),
          _c("i", {
            staticClass: "fas text-primary fa-project-diagram fa-fw float-right"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "ml-2 header-filter-btns",
          class: _vm.isActive("contacts") ? "active" : "",
          attrs: { variant: "theme" },
          on: {
            click: function($event) {
              return _vm.activateTab("contacts")
            }
          }
        },
        [
          _vm._v("\n      Contacts\n      "),
          _c("i", {
            staticClass: "far text-primary fa-id-badge fa-fw float-right"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "ml-2 header-filter-btns",
          class: _vm.isActive("coordinators") ? "active" : "",
          attrs: { variant: "theme" },
          on: {
            click: function($event) {
              return _vm.activateTab("coordinators")
            }
          }
        },
        [
          _vm._v("\n      Users\n      "),
          _c("i", {
            staticClass: "far text-primary fa-user-circle fa-fw float-right"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "ml-2 header-filter-btns",
          class: _vm.isActive("tags") ? "active" : "",
          attrs: { variant: "theme" },
          on: {
            click: function($event) {
              return _vm.activateTab("tags")
            }
          }
        },
        [
          _vm._v("\n      Tags\n      "),
          _c("i", {
            staticClass: "fas text-primary fa-hashtag fa-fw float-right"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }